import React, { Fragment, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { FormTextField, IconFormTextField } from "../../../components/generic/GenericTextFields";
import { EditProfileButtons } from "./EditProfileButtons";
import useStore from "../../../states/store";
import useNotiStack from "../../../hooks/useNotiStack";
import { VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import { createOrUpdateUserDetails } from "../../../config/apisauce";
import { useFormik } from "formik";
import { AddressBook } from "@phosphor-icons/react";
import { object, string } from "yup";

export const EditContactForm = ({ handleClose, creatorDetails, refetchDetails, isPage = true }) => {
  const { success } = useNotiStack();
  const [, { setLoggedIndUserDetails }] = useStore();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    const params = {
      ...values,
      user_id: creatorDetails?.user_id,
      current_step: VERIFY_FACE_ID_KEY
    };
    const { data, ok } = await createOrUpdateUserDetails(params);
    if (ok) {
      if (isPage) {
        setLoggedIndUserDetails({
          ...creatorDetails,
          contact_details: data?.contact_details,
          instructions: data?.instructions
        });
      } else {
        refetchDetails();
      }
      handleClose();
      success('Successfully updated contact details!');
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      contact_details: creatorDetails?.contact_details ?? "",
      instructions: creatorDetails?.instructions ?? "",
    },
    enableReinitialize: true,
    validationSchema: object().shape({
      instructions: string().trim().required('Instruction/Requirement Details is required')
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <Fragment>
      <Typography color="#454F5B">
        Please fill out the form below with your preferred contact method and your requirements for a collab request including how to be contacted.
      </Typography>
      <Stack mt={2.5} gap={2}>
        <IconFormTextField
          value={formik?.values.contact_details}
          color={'text.main'}
          isRequired={false}
          label={'Collab Contact Method:'}
          placeholder={'https://telegram.me/username'}
          icon={<AddressBook size={20} color="#454F5B" />}
          handleChange={(value) => formik.setFieldValue('contact_details', value)}
        />
        <FormTextField
          value={formik?.values.instructions}
          multiline={true}
          color={'text.main'}
          isRequired={false}
          label={'Instruction/Requirement Details:'}
          placeholder={'Type here...'}
          handleChange={(value) => formik.setFieldValue('instructions', value)}
          error={Boolean(formik?.errors?.instructions)}
          helperText={formik?.errors?.instructions}
        />
      </Stack>
      <EditProfileButtons
        loading={loading}
        handCancel={() => handleClose()}
        handleSubmit={() => formik?.handleSubmit()}
      />
    </Fragment>
  );
};